import { render, staticRenderFns } from "./CostDiffDetail.vue?vue&type=template&id=4557ceef&scoped=true"
import script from "./CostDiffDetail.vue?vue&type=script&lang=js"
export * from "./CostDiffDetail.vue?vue&type=script&lang=js"
import style0 from "./CostDiffDetail.vue?vue&type=style&index=0&id=4557ceef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557ceef",
  null
  
)

export default component.exports